(function () {
	'use strict';

    angular.module("imApp").factory("docArticleTopUserGroupService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1383,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1384,
                    parameters: edit
                });
            }
		};

		return service;
	}]);
})();
